/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Verify_TitleInputs */

const en_wc_dl_verify_title = /** @type {(inputs: Wc_Dl_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify your download`)
};

/**
* | output |
* | --- |
* | "Verify your download" |
*
* @param {Wc_Dl_Verify_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_verify_title = /** @type {((inputs?: Wc_Dl_Verify_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Verify_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_verify_title(inputs)
});
export { wc_dl_verify_title as "wc.dl.verify_title" }